/**
 * B.Tech column names on the `applications` resource.
 * When adding/changing fields, update:
 * - backend: applications.json (java + static/ui/json)
 * - this file
 * - applicantValidator.ts (rules referencing these keys)
 */

export const BTechApplicationFields = {
  edu10: {
    level: "edu10_level",
    board: "edu10_board",
    specialization: "edu10_specialization",
    schoolname: "edu10_schoolname",
    passingyear: "edu10_passingyear",
    marksobtained: "edu10_marksobtained",
    maximummarks: "edu10_maximummarks",
    marksformat: "edu10_marksformat",
    grade: "edu10_grade",
    percentage: "edu10_percentage"
  },
  edu12: {
    level: "edu12_level",
    board: "edu12_board",
    percentagemaths: "edu12_percentagemaths",
    schoolname: "edu12_schoolname",
    marksobtained: "edu12_marksobtained",
    maximummarks: "edu12_maximummarks",
    passingyear: "edu12_passingyear",
    marksformat: "edu12_marksformat",
    grade: "edu12_grade",
    percentage: "edu12_percentage"
  },
  olympiad: {
    name: "olympiad_name",
    no: "olympiad_no",
    proof: "olympiad_proof",
    year: "olympiad_year",
  },
  jeemain: {
    examtype: "jeemain_examtype",
    rollno: "jeemain_rollno",
    score: "jeemain_score",
    rank: "jeemain_rank",
    scorecard: "jeemain_scorecard",
  },
  jeeadv: {
    examtype: "jeeadv_examtype",
    rollno: "jeeadv_rollno",
    score: "jeeadv_score",
    rank: "jeeadv_rank",
    scorecard: "jeeadv_scorecard",
  },
} as const;

/** Long / numeric fields on applications payload (coerced before save) */
export const BTechNumericApplicationKeys = new Set<string>([
  "edu10_maximummarks",
  "edu12_marksobtained",
  "edu12_maximummarks",
  "edu12_passingyear",
  "edu12_percentagemaths",
  "olympiad_year",
  "jeemain_score",
  "jeeadv_score",
]);
